import React, { useState } from 'react';
import Modal from '@carvana/showroom-modal';
import {
  ModalContent,
  ModalMessage,
  SadCarImage,
  SupportMessage,
  HyperLink,
} from './BankPaymentError.styles';
import { currentAssetsUrl } from '../../../utils/baseUrlUtil';

const BankPaymentError = ({ openModal, toggleModal }: any) => {
  const [openErrorModal, setErrorModal] = useState(openModal);

  const closeModal = () => {
    toggleModal();
    setErrorModal(!openErrorModal);
  };

  return (
    <Modal
      headerText="Oops, something went wrong"
      closeModal={closeModal}
      isOpen={openErrorModal}
      testHook="payment-error-modal"
      mode="light"
      portalDivId="payment-error"
    >
      <ModalContent>
        <SadCarImage
          src={`${currentAssetsUrl(
            process.env.NODE_ENV
          )}/emblem/90f86c4a-2ce5-4586-8004-e2c3c9b89ab1.svg`}
        />
        OOPS, SORRY!
        <ModalMessage>
          Something went wrong. The information you entered may be incorrect. We
          are unable to connect to your bank account
        </ModalMessage>
        <SupportMessage>
          Please call Bridgecrest support at:{' '}
          <HyperLink href="tel:8009678526" type="external">800-967-8526</HyperLink>
          <br />
          Or manage at:{' '}
          <HyperLink href="www.bridgecrest.com" target="_blank" type="external">
            www.bridgecrest.com
          </HyperLink>
        </SupportMessage>
      </ModalContent>
    </Modal>
  );
};

export default BankPaymentError;
